<template>
  <div class="container">
    <div>
      <img style="width: 50px; height: 50px" src="../../assets/img/loading.gif" alt="" />
    </div>
  </div>
</template>

<script>
import { getH5SkipConfig, getAppVersionConfig, checkWapUrl } from '@/api/data'

export default {
  data() {
    return {
      // 二维码id 小程序的活动二维码 id 1593500061927473152   app个人主页二维码id   1593222136602820608
      // code: "investActivityDetail"
      // createdTs: "1668754995604"
      // id: "1593500061927473152"
      // path: "subpackage-investment/pages/activity/index"
      // query: "activityId=560"
      // remark: "活动二维码"
      // skipType: 1
      // status: 1
      // wxH5Link: null
      id: '',
      type: '',

      appQuery: '',

      downloadUrl: '',
    }
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id || ''
    this.type = this.$route.query.type || ''
    this.fetchDownloadData()
    this.fetchData()
  },
  methods: {
    async fetchDownloadData() {
      getAppVersionConfig('ysh_product').then((res) => {
        this.downloadUrl = res.data.data.fullUpdateInfo.downloadUrl
      })
    },
    async fetchData() {
      //app内部链接打开  type是由app自身去拼接的
      if (this.type == 'app') {
        const res = await getH5SkipConfig(this.id, '2')
        if (res.data.state !== 1) return

        // this.openApp("yshapp://" + res.data.data.code + "?" + res.data.data.query)
        var nativeData = {
          code: res.data.data.code,
          query: res.data.data.query,
        }

        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端

        if (isAndroid) {
          window.YshApp.goToPage(JSON.stringify(nativeData))
        } else if (isiOS) {
          window.webkit.messageHandlers.goToPage.postMessage(JSON.stringify(nativeData))
        }
      } else {
        // 外部短信、浏览器等等  跳转到内部应用app、小程序
        const {
          data: { state, data },
        } = await getH5SkipConfig(this.id, '1')
        if (state === 1) {
          //小程序
          if (data.skipType === 1) {
            //https://wxaurl.cn/Qr4AS4iH1sl
            //https://wxmpurl.cn/Qr4AS4iH1sl

            try {
              const res = await checkWapUrl(data.wxH5Link)

              if (res.status == 200) {
                window.location.href = data.wxH5Link
              } else {
                this.replaceWapUrl(data.wxH5Link)
              }
            } catch (error) {
              this.replaceWapUrl(data.wxH5Link)
            }
          } else {
            //app  newFriend
            this.skipApp(data.code, data.query)
          }
        }
      }
    },

    replaceWapUrl(wxH5Link) {
      const search = 'wxaurl'
      const replaceWith = 'wxmpurl'

      const result = wxH5Link.split(search).join(replaceWith)
      window.location.href = result
    },

    skipApp(code, query) {
      if (query) {
        this.appQuery = code + '?' + query.substring(0, query.lastIndexOf('&'))
      } else {
        this.appQuery = code
      }

      if (this.isEvn() == 'Android') {
        this.appQuery = 'yshapp://ysh:8888/' + this.appQuery
        this.submitFn()
      } else {
        this.$router.push({ path: 'download', query: { path: code } })
      }
    },

    isEvn() {
      //判断浏览器
      var u = navigator.userAgent
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        return 'Android'
      } else if (u.indexOf('iPhone') > -1) {
        return 'iPhone'
      }
    },

    submitFn() {
      //判断浏览器
      var u = navigator.userAgent
      if (/MicroMessenger/gi.test(u)) {
        // 引导用户在浏览器中打开
        alert('请在浏览器中打开')
        return
      }
      var d = new Date()
      var t0 = d.getTime()
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        //Android
        this.openApp(this.appQuery)
        let that = this
        var delay = setInterval(function () {
          var d = new Date()
          var t1 = d.getTime()
          if (t1 - t0 < 3000 && t1 - t0 > 2000) {
            // alert('请下载APP')
            window.location.href = that.downloadUrl
          }
          if (t1 - t0 >= 3000) {
            clearInterval(delay)
          }
        }, 1000)
      }
    },

    openApp(src) {
      // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
      // 否则打开a标签的href链接
      var ifr = document.createElement('iframe')
      ifr.src = src
      ifr.style.display = 'none'
      document.body.appendChild(ifr)
      window.setTimeout(function () {
        document.body.removeChild(ifr)
      }, 2000)
    },
  },
}
</script>

<style lang="less">
.container {
  width: 100%;
  text-align: center;
  margin-top: 35vh;
}
</style>
